import { useState } from "react";
import { Modal, Button } from "rsuite";
import { useNavigate } from "react-router-dom";
import RemindIcon from "@rsuite/icons/legacy/Remind";

const MealTrial = (props) => {
  const { data, changeDay } = props;
  const [open, setOpen] = useState(true);
  const [isLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="meal-trial">
      <Modal
        backdrop="static"
        role="alertdialog"
        open={open}
        onClose={handleClose}
        size="xs"
      >
        <Modal.Header closeButton={true}></Modal.Header>
        <Modal.Body>
          <RemindIcon style={{ color: "#ffb300", fontSize: 24 }} />
          {data.body ? <div className="body">{data.body}</div> : ""}
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance={isLoading ? "default" : "primary"}
            loading={isLoading}
            onClick={save}
            block
          >
            <b style={{ color: "#fff" }}>{data.button ? data.button : ""}</b>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );

  function handleClose() {
    setOpen(false);
    changeDay(0);
  }

  function save() {
    navigate("/subscription-packages");
    return false;
  }
};

export default MealTrial;
